import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Profile.css';

const Profile: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <div className="profile-loading">Loading profile...</div>;
  }

  const getCreditsInfo = () => {
    if (!user.credits) return null;

    const total = user.credits.total;

    return (
      <div className="profile-card">
        <h2 className="card-title">Credits</h2>
        
        <div className="credits-overview">
          <div className="credits-circle">
            <div className="credits-number">
              <span className="credits-remaining">{total}</span>
              <span className="credits-total">Credits</span>
            </div>
          </div>

          <div className="credits-details">
            <div className="credit-stat">
              <span className="stat-label">Resume Credits Remaining</span>
              <span className="stat-value">{total}</span>
            </div>
          </div>
        </div>

        <div className="credits-info-box">
          <p>
            💡 Use your credits to build professional, ATS-friendly resumes and prepare for interviews with AI-guided questions.
            {total === 0 && ' Purchase more credits to continue!'}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1>Your Profile</h1>
        <p className="profile-subtitle">Manage your account and preferences</p>
      </div>

      <div className="profile-content">
        {/* User Info Card */}
        <div className="profile-card">
          <h2 className="card-title">Account Information</h2>
          
          <div className="profile-info">
            <div className="profile-avatar-section">
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name}
                  className="profile-avatar-large"
                />
              ) : (
                <div className="profile-avatar-placeholder-large">
                  {user.name.charAt(0).toUpperCase()}
                </div>
              )}
            </div>

            <div className="profile-details">
              <div className="profile-detail-row">
                <span className="detail-label">Name</span>
                <span className="detail-value">{user.name}</span>
              </div>

              <div className="profile-detail-row">
                <span className="detail-label">Email</span>
                <span className="detail-value">{user.email}</span>
              </div>

              <div className="profile-detail-row">
                <span className="detail-label">User ID</span>
                <span className="detail-value detail-value-mono">{user.id}</span>
              </div>

              <div className="profile-detail-row">
                <span className="detail-label">Account Tier</span>
                <span className="detail-value">
                  <span className="tier-badge">Free</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Credits Card */}
        {getCreditsInfo()}

        {/* Account Actions */}
        <div className="profile-card">
          <h2 className="card-title">Account Actions</h2>
          
          <div className="action-buttons">
            <button className="action-btn action-btn-secondary" disabled>
              <span className="action-icon">⬆️</span>
              <div className="action-content">
                <div className="action-title">Upgrade to Premium</div>
                <div className="action-description">Coming soon</div>
              </div>
            </button>

            <button className="action-btn action-btn-secondary" disabled>
              <span className="action-icon">📊</span>
              <div className="action-content">
                <div className="action-title">View Analytics</div>
                <div className="action-description">Coming soon</div>
              </div>
            </button>

            <button className="action-btn action-btn-secondary" disabled>
              <span className="action-icon">📥</span>
              <div className="action-content">
                <div className="action-title">Export My Data</div>
                <div className="action-description">Coming soon</div>
              </div>
            </button>

            <button className="action-btn action-btn-danger" disabled>
              <span className="action-icon">🗑️</span>
              <div className="action-content">
                <div className="action-title">Delete Account</div>
                <div className="action-description">Coming soon</div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;

